export default __webpack_public_path__ + "static/media/HistoryEmpty1.30337cec.svg";